import { ReactNode } from 'react';

import {
  FilterChip,
  FilterViewerComponentProps,
} from '@spotify/confidence-core-react';

import { useWorkflowExtensions } from '../../hooks';
import { normalizeTypeId } from './TypeFilterEditor';

import styles from './TypeFilterViewer.module.css';

export const TypeFilterViewer = (
  props: FilterViewerComponentProps<string[]>,
) => {
  const { value } = props;
  const extensions = useWorkflowExtensions();

  let label: ReactNode;

  if (!value || value.length === 0) {
    label = `No ${props.filter.label} selected`;
  } else if (value.length === 1) {
    const ext = extensions.find(
      w => normalizeTypeId(w.workflowId) === value[0],
    );
    const Icon = ext?.workflowIcon;
    label = (
      <>
        {props.filter.label}:{' '}
        {Icon && (
          <span className={styles.chipIcon}>
            <Icon />
          </span>
        )}
        {ext?.title ?? value[0]}
      </>
    );
  } else {
    label = `${props.filter.label}s (${value.length})`;
  }

  return <FilterChip {...props} label={label} />;
};
